import { useQuery } from '@tanstack/react-query'
import { Select, Input ,AutoComplete} from 'antd'
import moment from 'moment'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Header from '@components/header'
import Layout from '@components/Layout'
import { useDebounce } from '@hooks/useDebounce'
import { debouncedSet } from '@utils/debounce';
import { downloadExcel } from '@utils/downloadPdf'
import { fetchItemsSelect, fetchDepartments, fetchServiceReports , fetchWarehouseSelect, } from '@utils/fetchData'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'

import { http } from '../../services/http';

	const fetchWorkers = async ({ queryKey }) => {
		const [_] = queryKey

		try {
			const url = `api/users?role=Worker`
			const { data } = await http.get(url)
			return data
		} catch (error) {
			console.log(error)
		}
	}

const ServiceReports = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const formattedDate = moment().format('YYYY-MM-DD')

	const [endDateStart, setEndDateStart] = useState('')
	const [endDateEnd, setEndDateEnd] = useState("")
	const [startDateStart,setStartDateStart] = useState("")
	const [startDateEnd,setStartDateEnd] = useState("")
	const [endTimeMin, setEndTimeMin] = useState('')
	const [endTimeMax, setEndTimeMax] = useState('')
	const [warehouse, setWarehouse] = useState('')
	const [warehouseName, setWarehouseName] = useState('')
	const [service, setService] = useState('')
	const [worker, setWorker] = useState('')
	const [workerName, setWorkerName] = useState('')
	const [orderNumber, setOrderNumber] = useState('')
		const [serviceName, setServiceName] = useState('')
	const [searchServiceName, setSearchServiceName] = useState('')
	const [selectedServiceName, setSelectedServiceName] = useState('')


	const debouncedWarehouse = useDebounce(warehouse, 500)
	const debouncedWarehouseName = useDebounce(warehouseName, 500)
	const debouncedService = useDebounce(service, 500)
	const debouncedServiceName = useDebounce(serviceName, 500)
	const debouncedWorker = useDebounce(worker, 500)
	const debouncedWorkerName = useDebounce(workerName, 500)
	const debouncedOrderNumber = useDebounce(orderNumber, 500)

	const [pageSize] = useState(20)
	const [page, setPage] = useState(0)
	const [loadingExcel, setLoadingExcel] = useState(false)
	const [viewModalOpen, setViewModalOpen] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const { data = [], isLoading } = useQuery({
		queryKey: [
			'service-reports',
			pageSize,
			page,
						startDateStart,
			startDateEnd,
			endDateStart,
			endDateEnd,

			endTimeMin,
			endTimeMax,
			debouncedWarehouse,
			debouncedWarehouseName,
			debouncedService,
			selectedServiceName,
			debouncedWorker,
			debouncedWorkerName,
			debouncedOrderNumber,
		],
		queryFn: fetchServiceReports,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

		const { data: departmentData = [] } = useQuery({
		queryKey: ['departments'],
		queryFn: fetchDepartments,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

		const {
		data: workersData = [],
		isLoading: isLoadingWorkers,
		refetch: refetchWorkers,
	} = useQuery({
		queryKey: ['workers'],
		queryFn: fetchWorkers,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 30000,
	})


	const { data: itemsData = [], itemsLoading } = useQuery({
		queryKey: [
			'itemsServices',
			searchServiceName,
			'Услуги',
			'api/items/get-items',
		],
		queryFn: fetchItemsSelect,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
		refetchInterval: 60000,
	})


		const { data: whsData = [] } = useQuery({
			queryKey: ['whs'],
			queryFn: fetchWarehouseSelect,
			keepPreviousData: true,
			refetchOnWindowFocus: false,
		})


	const handleViewClick = (record) => {
		setSelectedRowData(record)
		setViewModalOpen(true)
	}

	const baseColumns = [

		{
			title: t('whsName'),
			dataIndex: 'whsName',
			key: 'whsName',
		},
		{
			title: t('serviceName'),
			dataIndex: 'serviceName',
			key: 'serviceName',
		},
		{
			title: t('masterName'),
			dataIndex: 'masterName',
			key: 'masterName',
		},
		{
			title: t('quantity'),
			dataIndex: 'U_Quantity',
			key: 'U_Quantity',
			render: (value) => numberWithSpacesIntl(value || 0),
		},
		{
			title: t('salesOrderDocNum'),
			dataIndex: 'salesOrderDocNum',
			key: 'salesOrderDocNum',
		},
			{
			title: t('startDate'),
			dataIndex: 'U_DocDate',
			key: 'U_DocDate',
			render: (value) => value ? moment(value).format('DD.MM.YYYY') : '-',
		},
			{
			title: t('startTime'),
			dataIndex: 'U_StartTime',
			key: 'U_StartTime',
		},
			{
			title: t('endDate'),
			dataIndex: 'U_EndDate',
			key: 'U_EndDate',
			render: (value) => value ? moment(value).format('DD.MM.YYYY') : '-',
		},
		{
			title: t('endTime'),
			dataIndex: 'U_EndTime',
			key: 'U_EndTime',
		},
	]

	const columns = [...baseColumns]

	const handleNextPage = () => {
		if (data.length === pageSize) {
			setPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (page > 0) {
			setPage((prevPage) => prevPage - 1)
		}
	}

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/reports/services-report/export',
			params: {
				endDateStart,
				endDateEnd,
				endTimeMin,
				endTimeMax,
				warehouse: debouncedWarehouse,
				warehouseName: debouncedWarehouseName,
				service: debouncedService,
				serviceName: debouncedServiceName,
				worker: debouncedWorker,
				workerName: debouncedWorkerName,
				orderNumber: debouncedOrderNumber,
				page: 0,
				pageSize: 1000,
			},
			fileName: t('serviceReports'),
			onLoadingChange: setLoadingExcel,
		})
	}

	return (
		<Layout>
			<Header
				title={'serviceReports'}
				columns={columns}
				fdata={data}
				loading={isLoading}
				hasMoreData={data.length === pageSize}
				currentPage={page + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				formattedDate={formattedDate}
				loadingExcel={loadingExcel}
				handleDownloadExcel={handleDownloadExcel}
				isShowExcelBtn
				renderFilters={() => {
					return (
						<div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 items-end gap-4">
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('startDateStart')}</p>
								<Input
									type="date"
									value={startDateStart}
									onChange={(e) => setStartDateStart(e.target.value)}
									placeholder={t('startDateStart')}
									allowClear
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('startDateEnd')}</p>
								<Input
									type="date"
									value={startDateEnd}
									onChange={(e) => setStartDateEnd(e.target.value)}
									placeholder={t('startDateEnd')}
									allowClear
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('endDateStart')}</p>
								<Input
									type="date"
									value={endDateStart}
									onChange={(e) => setEndDateStart(e.target.value)}
									placeholder={t('startDate')}
									allowClear
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('endDateEnd')}</p>
								<Input
									type="date"
									value={endDateEnd}
									onChange={(e) => setEndDateEnd(e.target.value)}
									placeholder={t('endDate')}
									allowClear
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('endTimeMin')}</p>
								<Input
									type="time"
									value={endTimeMin}
									onChange={(e) => setEndTimeMin(e.target.value)}
									placeholder={t('endTimeMin')}
									allowClear
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('endTimeMax')}</p>
								<Input
									type="time"
									value={endTimeMax}
									onChange={(e) => setEndTimeMax(e.target.value)}
									placeholder={t('endTimeMax')}
									allowClear
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('whs')}</p>
								<Select
									value={warehouse}
									className="flex h-8 w-full items-center justify-center "
									style={{ color: 'black' }}
									onSelect={(val,label) => {
										setWarehouse(val)
										setWarehouseName(label?.label)
									}}
									options={whsData.map((department) => {
										return {
											label: department.warehouseName,
											value: department.warehouseCode,
										}
									})}
									filterOption={(input, option) =>
										option.label
											.toLowerCase()
											.includes(input.toLowerCase())
									}
									showSearch
									allowClear
									onClear={() => {
										setWarehouse('')
									}}
								/>
							</div>
							{/* <div className="flex flex-col gap-1">
								<p className="font-nunito">{t('serviceName')}</p>
								<Input
									value={serviceName}
									onChange={(e) => setServiceName(e.target.value)}
									placeholder={t('serviceName')}
									allowClear
								/>
							</div> */}
									<div className="flex flex-col gap-2 col-span-2">
						<p>{t('serviceName')}</p>
						<AutoComplete
							loading={itemsLoading}
							options={itemsData?.map((item) => ({
								value: item.itemCode,
								label: item.itemName,
							}))}
							className="min-w-[300px] h-8"
							value={serviceName}
							onSelect={async (value, label) => {
								setServiceName(label.label)
								setSearchServiceName('')
								setSelectedServiceName(label.label)
							}}
							onChange={(val) => {
								const value = val || ''
								setServiceName(value)
								debouncedSet(value, setSearchServiceName)
								if (value === '') {
									setSelectedServiceName('')
								}
							}}
							showSearch
						/>
					</div>

								<div className="flex flex-col gap-2">
						<p>{t('workerName')}</p>
						<Select
							// className="w-[200px] h-8"
							options={[
								{
									value: '',
									label: t('all'),
								},
								...workersData.map((worker) => {
									return {
										value: worker.employeeId,
										label: `${worker.firstName} ${worker.lastName}`,
									}
								}),
							]}
							allowClear
							onChange={setWorker}
							value={worker}
						/>
					</div>
							<div className="flex flex-col gap-1">
								<p className="font-nunito">{t('numZakaz')}</p>
								<Input
									value={orderNumber}
									onChange={(e) => setOrderNumber(e.target.value)}
									placeholder={t('numZakaz')}
									allowClear
								/>
							</div>
						</div>
					)
				}}
			/>

		</Layout>
	)
}

export default ServiceReports
